/**
 * My Guy BBQ Co. - Search & Predictive Search
 */
document.addEventListener('DOMContentLoaded', function () {
  const searchForm = document.getElementById('searchform');
  const searchInput = document.getElementById('searchInput');
  const searchBtn = document.getElementById('searchBtn');
  let predictiveDropdown = document.getElementById('predictiveSearchResults');

  if (!searchForm || !searchInput) return;

  // Create dropdown container if not already in markup
  if (!predictiveDropdown) {
    predictiveDropdown = document.createElement('div');
    predictiveDropdown.id = 'predictiveSearchResults';
    predictiveDropdown.className = 'predictive-search-dropdown';
    searchForm.appendChild(predictiveDropdown);
  }

  let debounceTimer = null;
  let currentQuery = '';

  // Format price helper
  function formatMoney(centsOrString) {
    if (!centsOrString && centsOrString !== 0) return '';
    var str = String(centsOrString);
    if (str.indexOf('$') !== -1) return str;
    var num = parseFloat(str);
    if (isNaN(num)) return str;
    return '$' + num.toFixed(2);
  }

  // Close predictive dropdown
  function closeDropdown() {
    if (predictiveDropdown) {
      predictiveDropdown.classList.remove('is-visible');
      predictiveDropdown.innerHTML = '';
    }
  }

  // Render predictive results
  function renderResults(products, query) {
    if (!predictiveDropdown) return;

    if (!products || products.length === 0) {
      predictiveDropdown.innerHTML = `
        <div class="predictive-search-status">
          No products found for "${query}".
        </div>
        <div class="predictive-search-footer">
          <a class="predictive-search-view-all" href="/search?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(query)}">
            Search all results &rarr;
          </a>
        </div>
      `;
      predictiveDropdown.classList.add('is-visible');
      return;
    }

    var html = '<ul class="predictive-search-list">';
    products.forEach(function (product) {
      var imageHtml = product.image
        ? `<img src="${product.image}" alt="${product.title.replace(/"/g, '&quot;')}" loading="lazy" />`
        : `<i class="fa-solid fa-bottle-droplet" style="color:#aaa;"></i>`;

      var priceHtml = product.price ? `<p class="predictive-search-price">${formatMoney(product.price)}</p>` : '';

      html += `
        <li class="predictive-search-item">
          <a class="predictive-search-link" href="${product.url}">
            <div class="predictive-search-thumb">
              ${imageHtml}
            </div>
            <div class="predictive-search-info">
              <h4 class="predictive-search-title">${product.title}</h4>
              ${priceHtml}
            </div>
          </a>
        </li>
      `;
    });
    html += '</ul>';
    html += `
      <div class="predictive-search-footer">
        <a class="predictive-search-view-all" href="/search?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(query)}">
          View all results for "${query}" &rarr;
        </a>
      </div>
    `;

    predictiveDropdown.innerHTML = html;
    predictiveDropdown.classList.add('is-visible');
  }

  // Fetch predictive suggestions from Shopify API
  function fetchSuggestions(query) {
    if (!query || query.trim().length < 2) {
      closeDropdown();
      return;
    }

    currentQuery = query.trim();

    fetch(`/search/suggest.json?q=${encodeURIComponent(currentQuery)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=show`)
      .then(function (res) {
        if (!res.ok) throw new Error('Network error');
        return res.json();
      })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products, currentQuery);
      })
      .catch(function (err) {
        console.warn('Predictive search error:', err);
      });
  }

  // Input event listener with 250ms debounce
  searchInput.addEventListener('input', function () {
    var val = searchInput.value;
    clearTimeout(debounceTimer);
    if (!val || val.trim().length < 2) {
      closeDropdown();
      return;
    }
    debounceTimer = setTimeout(function () {
      fetchSuggestions(val);
    }, 250);
  });

  // Close dropdown on click outside or when input loses focus
  document.addEventListener('click', function (e) {
    if (!searchForm.contains(e.target)) {
      closeDropdown();
      // If search input is active and empty, close the input bar
      if (searchInput.classList.contains('active') && searchInput.value.trim() === '') {
        searchInput.classList.remove('active');
      }
    }
  });

  // Handle ESC key to close search / dropdown
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDropdown();
      if (searchInput.classList.contains('active') && searchInput.value.trim() === '') {
        searchInput.classList.remove('active');
      }
    }
  });
});

